import { useEffect, useState } from 'react';

// controllers
import { UserController } from 'controllers';

// components
import { ModalFeedbacks } from './modal-feedbacks';

// functions
import { useToggle } from 'shared/functions';

const labelMap = {
    unliked_items: { label: 'Didn\'t like it', important: true },
    liked_items: { label: 'Liked it' },
    loved_items: { label: 'Loved it' },
    too_small: { label: 'Too small', important: true },
    perfect_items: { label: 'Perfect' },
    too_big: { label: 'Too big', important: true },
    receive_again: { label: 'Wants again' }
};

const FeedbackItem = ({ customer, name, className, modalDisabled = true }) => {
    const [modal, setModal] = useToggle(false);
    const [items, setItems] = useState([]);
    const [count, setCount] = useState(0);
    const { label, important } = labelMap[name];
    const color = important ? 'is-primary' : 'is-dark';

    useEffect(() => {
        const getCustomer = async () => {
            const data = await UserController.getUserCollection(customer.id, name);
            setCount(data.length);
            setItems(data);
        }

        if (customer?.id) {
            getCustomer();
        }
    }, [customer, name]);

    return (
        <div className="tags has-addons">
            <span className={`tag is-white is-125px ${className}`}>{label}</span>
            <span className={`tag ${!modalDisabled && 'button'} ${color} ${className}`} onClick={setModal} >{count}</span>
            {!modalDisabled && <ModalFeedbacks modal={modal} handleModal={setModal} items={items} label={label} />}
        </div>
    );
};

const Feedbacks = ({ customer }) => {

    return (
        <div className="is-flex-mobile is-justify-content-space-around is-align-items-baseline">
            <div className="columns mt-4 is-centered is-multiline">
                <div className="column is-12-mobile"><p className="subtitle">Overall feedback</p></div>
                {['unliked_items', 'liked_items', 'loved_items', 'receive_again'].map((item) => (
                    <div key={item} className="column is-2-desktop is-12-mobile">
                        <FeedbackItem className="is-large" customer={customer} name={item} modalDisabled={false} />
                    </div>
                ))}
            </div>

            <div className="columns is-centered is-multiline">
                <div className="column is-12-mobile"><p className="subtitle">Size</p></div>
                {['too_small', 'perfect_items', 'too_big'].map((item) => (
                    <div key={item} className="column is-2-desktop is-12-mobile">
                        <FeedbackItem className="is-large" customer={customer} name={item} modalDisabled={false} />
                    </div>
                ))}
                <div className="column is-2 is-hidden-mobile"></div>
            </div>
        </div>
    );

}

export { Feedbacks };
